module.exports = __webpack_public_path__ + "img/drop_down.96f43c92.svg";